module.exports = __webpack_public_path__ + "static/media/faust.fb24dca2.svg";